import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMove = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlSpace: "preserve",
	fillRule: "evenodd",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeMiterlimit: 1.4,
	clipRule: "evenodd",
	viewBox: "0 0 1024 1024",
	width: "1em",
	height: "1em",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			d: "M0 0h1024v1024H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 61.11,
			d: "M512 128v704",
			transform: "matrix(0 1.17977 -1.17677 0 1076.849 -92.042)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0013631,
			d: "M209.98 624.202 97.776 512l112.202-112.202M814.015 399.798 926.217 512 814.015 624.202"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 61.11,
			d: "M512 128v704",
			transform: "matrix(-1.17977 0 0 -1.17677 1116.042 1076.849)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 72.0013631,
			d: "M399.798 209.98 512 97.776l112.202 112.202M624.202 814.015 512 926.217 399.798 814.015"
		})
	]
});
export default SvgIconMove;
